import * as angular from "angular";
import {IController} from "angular";
import {LocationType} from "../../../commons/types/location.type";
import {TaskModel} from "../../../tasks/models/task.model";

export class OmsOrdersTableRowTaskComponent implements IController {

  task: TaskModel;
  columns: any;

  public locationTypes: typeof LocationType = LocationType;

  constructor() {
  }

  $onInit() {
  }

}

angular
  .module('bringoz.admin.oms')
  .component('omsOrdersTableRowTask', {
    bindings: {
      task: '<',
      columns: '<?'
    },
    template: require('./oms-orders-table-row-task.html').default,
    controller: OmsOrdersTableRowTaskComponent
  });
